<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Advent und Weihnachten</h3>
      </div>
    </div>
    <div class="section section-work-images">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-1.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-2.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-3.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-4.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-5.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-6.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-7.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-8.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-9.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-10.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-11.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-12.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/christmas/christmas-13.jpg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'christmas',
  bodyClass: 'christmas-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
